import type { UnknownAction } from '@reduxjs/toolkit';
import { hash } from 'immutable';

import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import { coreActions } from '../core-actions';
import * as actions from './alertsActions';
import type { AlertProps } from './alertsTypes';

export const QcsSyncAlertsStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<AlertProps>({
  resourceName: 'ALERTS',
});

function alertsReducer(
  state: QcsSyncResourceStore<AlertProps> = QcsSyncAlertsStoreFactory(),
  action: UnknownAction,
): typeof state {
  switch (true) {
    case coreActions.sanitize.match(action):
      return state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.merge({
            message: hash(resource.message).toString(),
          }),
        ),
      );
    case actions.updateAlert.match(action):
      return resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateAlert);
    case actions.updateAlertSuccess.match(action):
      return resourceUpserters.upsertResource(state, action.payload);
    case actions.getAlertsSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getAlertsFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);

    case actions.deleteAlert.match(action):
      return resourceUpserters.upsertResource(state, action.payload);
    case actions.deleteAlertSuccess.match(action):
      return resourceUpserters.upsertResource(state, action.payload);

    case actions.batchAlerts.match(action):
      return resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlerts, false);
    case actions.batchAlertsSuccess.match(action):
      return resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlerts, true);

    case actions.updateAlertFailure.match(action):
    case actions.deleteAlertFailure.match(action):
    case actions.batchAlertsFailure.match(action):
      return resourceUpserters.resetResources(state, action.payload);
    default:
      return state;
  }
}

export default alertsReducer;
